const actions = {
  getToken({ dispatch, commit, getters, rootGetters }, params) {
    return rootGetters['session/ajax'].post('/ase/get_token', { params });
  },
  confirmPurchase({ dispatch, commit, getters, rootGetters }, params) {
    return rootGetters['session/ajax'].post('/ase/confirm_purchase', params).then(response => {
      commit('user/set', response.data.user, { root: true });
      commit('purchaseReceipts/set', response.data.user.purchaseReceipts, { root: true });
      commit('userCertifications/reset', null, { root: true });
      commit('navigationItems/resetDynamicNavigationItems', null, { root: true });
      commit('userCertifications/setUserCertifications', response.data.user.userCertifications, { root: true });
      commit('navigationItems/setDynamicNavigationItems', rootGetters, { root: true });
      return response;
    });
  },
};

export default {
  namespaced: true,
  actions,
};
